/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_SovereignInputs */

const en_plan_sovereign = /** @type {(inputs: Plan_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign Plan`)
};

const es_plan_sovereign = /** @type {(inputs: Plan_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plan Sovereign`)
};

const fr_plan_sovereign = /** @type {(inputs: Plan_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forfait Sovereign`)
};

const de_plan_sovereign = /** @type {(inputs: Plan_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign-Plan`)
};

const ja_plan_sovereign = /** @type {(inputs: Plan_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign プラン`)
};

const zh_plan_sovereign = /** @type {(inputs: Plan_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign 计划`)
};

const ar_plan_sovereign = /** @type {(inputs: Plan_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خطة Sovereign`)
};

const id_plan_sovereign = /** @type {(inputs: Plan_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket Sovereign`)
};

const it_plan_sovereign = /** @type {(inputs: Plan_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Piano Sovereign`)
};

const ru_plan_sovereign = /** @type {(inputs: Plan_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тариф Sovereign`)
};

const pt_plan_sovereign = /** @type {(inputs: Plan_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plano Sovereign`)
};

const ko_plan_sovereign = /** @type {(inputs: Plan_SovereignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sovereign 요금제`)
};

/**
* | output |
* | --- |
* | "Sovereign Plan" |
*
* @param {Plan_SovereignInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const plan_sovereign = /** @type {((inputs?: Plan_SovereignInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_SovereignInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plan_sovereign(inputs)
	if (locale === "es") return es_plan_sovereign(inputs)
	if (locale === "fr") return fr_plan_sovereign(inputs)
	if (locale === "de") return de_plan_sovereign(inputs)
	if (locale === "ja") return ja_plan_sovereign(inputs)
	if (locale === "zh") return zh_plan_sovereign(inputs)
	if (locale === "ar") return ar_plan_sovereign(inputs)
	if (locale === "id") return id_plan_sovereign(inputs)
	if (locale === "it") return it_plan_sovereign(inputs)
	if (locale === "ru") return ru_plan_sovereign(inputs)
	if (locale === "pt") return pt_plan_sovereign(inputs)
	return ko_plan_sovereign(inputs)
});